import React from 'react'
import PropTypes from 'prop-types'
import TriggeredAlertsTab from './TriggeredAlerts/TriggeredAlertsTab'

const AlertsContent = ({
  collectId, draftId = null, hasVariables = false,
  initialColumnPreferences = null, isAdmin = false
}) => (
  <div data-has-variables={hasVariables}>
    <TriggeredAlertsTab
      collectId={collectId}
      draftId={draftId}
      initialColumnPreferences={initialColumnPreferences}
      isAdmin={isAdmin}
    />
  </div>
)

AlertsContent.propTypes = {
  collectId: PropTypes.number.isRequired,
  draftId: PropTypes.number,
  hasVariables: PropTypes.bool,
  initialColumnPreferences: PropTypes.shape({}),
  isAdmin: PropTypes.bool
}

AlertsContent.defaultProps = {
  draftId: null,
  hasVariables: false,
  initialColumnPreferences: null,
  isAdmin: false
}

export default AlertsContent
